/** @format */
import { css } from 'styled-components';

import { LinkSize } from '@toucan/client/shared/components/link';

import {
    LinkListSeparator,
    LinkListVariant,
    StyledLinkListItemProps,
} from './index';

/**
 * Separator styles for the Link List component
 */
const separatorStyles = ({ separator }: StyledLinkListItemProps) => {
    switch (separator) {
        case LinkListSeparator.SLASH:
            return css`
                li {
                    &:after {
                        content: '/';
                    }
                }
            `;
        case LinkListSeparator.DOT:
            return css`
                li {
                    &:after {
                        content: '•';
                    }
                }
            `;
    }

    return css``;
};

/**
 * Size styles for the Link List component
 */
const separatorSizeStyles = ({ separatorSize }: StyledLinkListItemProps) => {
    switch (separatorSize) {
        case LinkSize.MEDIUM:
            return css`
                li {
                    &:after {
                        font-size: 1.6rem;
                        line-height: 1.5rem;
                    }
                }
            `;
        case LinkSize.SMALL:
        default:
            return css`
                li {
                    &:after {
                        font-size: 1.2rem;
                        line-height: 1.8rem;
                    }
                }
            `;
    }
};

/**
 *
 * Variant styles for the Link List component
 */
const variantStyles = ({ variant }: StyledLinkListItemProps) => {
    switch (variant) {
        case LinkListVariant.BLOCK:
            return css``;
        default:
        case LinkListVariant.INLINE:
            return css`
                li {
                    float: left;
                }
            `;
    }
};

/**
 * Base styles for the Link List component
 */
const baseStyles = () => css`
    margin: 0;
    padding: 0;
    list-style-type: none;
    &:after {
        visibility: hidden;
        display: block;
        font-size: 0;
        content: ' ';
        clear: both;
        height: 0;
    }
    li {
        &:after {
            color: var(--colors-text-primary);
            margin: 0 0.6rem;
        }
        &:last-child:after {
            content: '';
        }
    }
`;

/**
 * The Link List component styles
 */

export const styles = (props: StyledLinkListItemProps) => css`
    ${baseStyles()}
    ${separatorStyles(props)}
    ${separatorSizeStyles(props)}
    ${variantStyles(props)}
`;
